var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number"},[_c('CountDownCircle',{ref:"circle",staticClass:"circle"}),(_vm.counts[0])?_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.counts[0]))]):_vm._e(),_c('span',{staticClass:"after-seconds"},[_vm._v("秒後に開始")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }